import { Box, Typography, Card } from '@mui/material'
import styles from '../contactus.module.scss';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import PublicTransportation from './publicTransportation';

const Address = () => {

    const navigateBack = () => {
        setShowAddressComponent(true);
        setShowPrintButton(false);
    };
    const [showAddressComponent, setShowAddressComponent] = useState<boolean>(true);
    const [showPrintButton, setShowPrintButton] = useState<boolean>(false);
    const navigateTo = () => {
        setShowAddressComponent(false)
        setShowPrintButton(true);
        window.scroll(0, 200)
    };

    const handleClicktoMaps =()=>{
        window.open("https://www.google.com/maps/place/1232+Arrowhead+Ave,+Livermore,+CA+94551,+USA/@37.7132529,-121.7331306,17z/data=!3m1!4b1!4m6!3m5!1s0x808fe72817daab4f:0x973ffac1551ece82!8m2!3d37.7132529!4d-121.7305557!16s%2Fg%2F11dznvfsv7?entry=ttu")
    }
    return (
        <>
            <div className={styles.AddressLayout}>
                <Card className={styles.Cardcontainer}>

                    {showAddressComponent ?
                        <div style={{ display: "flex", padding: "24px", flexWrap: "wrap" }}>
                            <div>
                                <Typography className={styles.Header}>Address</Typography>
                                <div className={styles.addressContent}>
                                    Hindu Community and Cultural Center<br />
                                    1232 Arrowhead Ave.<br />
                                    Livermore, CA 94551<br />
                                    <span style={{ color: "#F05802" }}>info at livermoretemple dot org</span><br />
                                    <Typography style={{margin: "20px 0", fontWeight: "500"}}>Tax ID# 94-2427126; Inc #D0821589</Typography>
                                    <div style={{ lineHeight: "10px" }}>
                                        <p><b>Main Telephone :</b> (925) 449 6255</p>
                                        <p><b>Alt.Telephone : </b> (925) 449 6254</p>
                                        <p><b>Alt.Telephone : </b> (925) 455 6229</p>
                                        <p><b>Alt.Telephone :</b>  (925) 583 2077</p>
                                        <p><b>Alt.Telephone : </b> (925) 583 2078</p>
                                        <p><b>Fax :</b>  (925) 455 0404</p>
                                        <p><b>eFax :</b>  (925) 605 1731</p>
                                    </div>
                                </div>
                                <div style={{marginTop:"70px"}}>
                                    <Typography className={styles.Header}>Direction</Typography>
                                    <div>
                                        <Typography className={styles.directioncotent}>
                                            From I-580 in Livermore:<br />
                                            Exit N. Vasco Road.<br />
                                            Left on Scenic Ave.<br />
                                            Left on Arrowhead Avenue.<br />
                                            1232 Arrowhead Avenue.<br />
                                            Temple is on your right.<br />
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                            <Box sx={{ float: "right" }}>
                                <img src='/images/contactmap.png' style={{ maxWidth: "700px", width: "100%" }} />
                                <Typography onClick={handleClicktoMaps} style={{ color: "#F05802", cursor: "pointer" }}>Click here for driving directions.</Typography>
                                <Typography>
                                    <div onClick={navigateTo} style={{ color: "#F05802", cursor: "pointer" }}>
                                        Public Transportation
                                    </div>
                                </Typography>
                            </Box>
                        </div> : <PublicTransportation setShowAddressComponent={setShowAddressComponent}/>}
                    {showPrintButton ?
                        <>
                            <div onClick={navigateBack} className={styles.previousbutton}>
                                {/* <CustomLeftIcon /> */}
                            </div>
                          
                        </> : ""}
                </Card>
            </div>
        </>
    )
}
export default Address;
